import React, { useState } from 'react';
import styled from 'styled-components';
import useTranslation from 'next-translate/useTranslation';
import { useCurrentUser, userActions, useDispatch } from '../../../api';

import { TextRegular14, TextBold18 } from '../../common/Text';
import Dialog from '../../common/Dialog';
import CentralizeButton from '../../../VuexyDesign/atoms/CentralizeButton';

const ManageTracks = () => {
  const dispatch = useDispatch();

  const { t } = useTranslation('myTracks');

  const { tracks_archived } = useCurrentUser();

  const [visible, setVisible] = useState(() => !!tracks_archived);

  const onDismiss = () => {
    setVisible(false);
    dispatch(userActions.tracksArchivedNotified());
  };

  return (
    <Dialog open={visible} hideCloseButton disableBackdropClick>
      <Container>
        <Content>
          <TextBold18>{t('myTracks:archivedMessage') as string}</TextBold18>
          &nbsp;
          <TextRegular14>
            {t('myTracks:freeUserNotification') as string}
            <strong>{t('myTracks:oneTrack') as string}</strong>
            {t('myTracks:manageTracks') as string}
          </TextRegular14>
        </Content>
        <ButtonsContainer>
          <CentralizeButton
            text={t('myTracks:manageMyTracks') as string}
            color="primary"
            size="md"
            href="/my-tracks"
            onClick={onDismiss}
          />
        </ButtonsContainer>
      </Container>
    </Dialog>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px;
  width: 700px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  margin-bottom: 28px;
`;

const ButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export default ManageTracks;
